import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Target } from "lucide-react";

export function BenchmarkCard({ benchmark }) {
  const bk = benchmark || {};
  return (
    <Card className="bg-white shadow-sm" data-testid="benchmark-card">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-gray-800">
          <Target className="w-5 h-5 text-blue-500" />
          Benchmark
        </CardTitle>
      </CardHeader>
      <CardContent>
        {bk.percentile ? (
          <div className="text-center space-y-4 py-4">
            <div className="inline-flex items-center justify-center w-28 h-28 rounded-full bg-blue-100">
              <span className="text-3xl font-black text-blue-600">Top {100 - bk.percentile + 1}%</span>
            </div>
            <p className="text-sm text-gray-500">Posição {bk.rank} de {bk.total_restaurants} restaurantes</p>
            <div className="grid grid-cols-3 gap-2">
              <div className="p-3 bg-gray-50 rounded-xl"><p className="text-lg font-bold text-gray-900">{bk.your_score}</p><p className="text-xs text-gray-500">Seu score</p></div>
              <div className="p-3 bg-gray-50 rounded-xl"><p className="text-lg font-bold text-gray-900">{bk.avg_score}</p><p className="text-xs text-gray-500">Média</p></div>
              <div className="p-3 bg-gray-50 rounded-xl"><p className="text-lg font-bold text-gray-900">{bk.top_score}</p><p className="text-xs text-gray-500">Melhor</p></div>
            </div>
          </div>
        ) : (
          <div className="text-center py-10">
            <Target className="w-12 h-12 mx-auto text-gray-300 mb-3" />
            <p className="text-sm text-gray-500">{bk.message || "Dados insuficientes para benchmark"}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
